import { heroEquipment } from "../HeroEquipment";

export const kapry = {
  heroes: {
    "Kapitan goblinów": {
      id: 0,
      startingEquipment: ["Sztylet", "Pistolet"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 7],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dowódca", "Dziwnie cuchnom", "Strachliwy"],
      exp: 20,
      skills: [0, 1, 3, 4, 5],
    },
    "Szaman goblinów": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 2, 1, 6],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dziwnie cuchnom", "Mag (Magia Małego Łooomotu!)"],
      exp: 12,
      skills: [0, 1, 4, 5],
    },
    "Goblin mat": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 2, 1, 6],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dziwnie cuchnom", "Podoficer"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Bohaterowie,
      type: "Bohater",
      stats: {
        "Początkowa": [4,3,3,3,3,1,2,1,6],
        "Maksymalna": [5,5,6,3,4,3,6,4,7]
      },
      rules: ["Dziwnie cuchnom", "Handlarz niewolników", "Żertwa"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    "Goblin pirat": {
      id: 5,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 15,
      number: 15,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 2, 1, 6],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Animozja","Chorążowie & sygnaliści","Drużyna ciężkich broni (harpun, ołowiomiotacz)","Drużyna obsługi","Dziwnie cuchnom","Rozmiar rzondzi"],
    },
    "Drużyna ciężkich broni": {
      id: 6,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 30,
      number: 2,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Ciężcy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 2, 1, 6],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Animozja",
        "Drużyna obsługi",
        "Dziwnie cuchnom",
        "Rozmiar rzondzi",
      ],
    },
    Snotling: {
      id: 7,
      startingEquipment: ["Broń improwizowana", "Wybuchowe zarodniki"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 2, 2, 1, 3, 1, 4],
        Maksymalna: [4, 2, 0, 2, 2, 1, 3, 1, 4],
      },
      rules: [
        "Mięso armatnie",
        "Nieświadomy",
        "Rozmiar rzondzi",
        "Sfora",
        "Śmigły",
        "Wybuchowe zarodniki",
      ],
    },
    Squig: {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["2K6", 4, 0, 5, 3, 1, 3, 2, 3],
        Maksymalna: ["2K6", 4, 0, 5, 3, 1, 3, 2, 3],
      },
      rules: [
        "Dzikie squigi",
        "Niezłomny",
        "No to hooop!",
        "Rozmiar rzondzi",
        "Zwierzę",
      ],
    },
    Kaper: {
      id: 9,
      startingEquipment: ["Pistolet"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Załoga Zielonoskórych Kaprów"].Kaper,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 2, 1, 10],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Dziwnie cuchnom",
        "Fanatyk",
        "Rajtar",
        "Celny strzał",
        "Wodny",
        "Zabójczy strzał",
      ],
    },
    Troll: {
      id: 10,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {
        "Troll Górski": [50, 3, "Choice"],
        "Troll Rzeczny": [50, 3, "Choice"],
      },
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 1, 3, 4],
        Maksymalna: [6, 3, 1, 5, 4, 3, 1, 3, 4],
      },
      rules: ["Bycza szarża","Duży cel","Gatunki trolli","Głód trzewi","Głupota","Nieświadomy","Niezłomny","Przepastne trzewia","Regeneracja","Strach","Wielkolud","Żrąca plwocina"],
    },
    "Ośmiornica bagienna": {
      id: 11,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["2K6", 3, "-", 4, 5, 3, 2, "K6+1", 5],
        Maksymalna: ["2K6", 3, "-", 4, 5, 3, 2, "K6+1", 5],
      },
      rules: ["Głód krwi","Głód trzewi","Kamuflaż","Murołaz","No to hooop!","Potwór","Stygmaty Nurgla (odór)","Ugryzienie","Wodny","Zbrojne kończyny","Zimnokrwisty","Zwiadowca","Zwierzę"],
    },
    Więźniarka: {
      id: 12,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        "Wielki wilk": [9, 3, 0, 4, "-", "-", 3, 1, 3],
        "Wielki wilk ": [9, 3, 0, 4, "-", "-", 3, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    Rydwan: {
      id: 13,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        "Wielki wilk": [9, 3, 0, 4, "-", "-", 3, 1, 3],
        "Wielki wilk ": [9, 3, 0, 4, "-", "-", 3, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Załoga Zielonoskórych Kaprów",
  nature: "Zła",
  armyRules: ["...Na ślinę i sznurek", "Podatek", "Rozrzutność"],
  mercenaries: ["Czarny Ork", "Grzybowar", "Mekaniak"],
};
